<template>
  <div class="grid-y flex-grow">
    <div class="cell auto cell-block-y flex flex-col flex-grow">
      <div class="grid-y divide-y flex-grow">
        <div class="cell py-6 px-8 flex flex-row space-x-6">
          <span
            class="cursor-pointer flex flex-row items-center"
            v-b-modal="'add'">
            <span class="btn-plus mr-2"></span>
            <b class="text-15px leading-21px text-primary">Добавить объект</b>
          </span>
          <VueUpload
            class="cursor-pointer flex flex-row items-center"
            @input-file="onInputUpdateCemeteries">
            <!-- eslint-disable -->
            <button
              :class="['cursor-pointer', $wait.is('update.cemeteries') ? 'opacity-50' : '']"
              :disabled="$wait.is('update.cemeteries')"
            >
              <b class="text-15px leading-21px text-primary">
                <template v-if="$wait.is('update.cemeteries')">
                  Обновление справочника захоронений...
                </template>
                <template v-else>
                  Обновить справочник захоронений
                </template>
              </b>
            </button>
            <!-- eslint-enable -->
          </VueUpload>
        </div>
        <div class="cell flex flex-col flex-grow">
          <Loading class="flex-grow" :loading="waitPending">
            <div class="flex-grow">
              <Table
                :columns="columns"
                :rows="objects"
                :row-style-class="() => 'cursor-pointer'"
                :busy="waitPending"
                @on-row-click="onRowClick"
                @on-sort-change="($event) => {orderBy = $event}"/>
            </div>
          </Loading>
          <div class="flex flex-row items-end justify-center p-6">
            <Pagination
              :page="page"
              :page-count="pageCount"
              @change="onPageChange"/>
          </div>
        </div>
        <Modal
          id="add"
          :hide-footer="true">
          <template v-slot:modal-title>
            <span class="modal-title">Добавление объекта</span>
          </template>
          <div slot class="flex flex-col items-center p-8">
            <p class="text-center text-16px leading-22px mb-6 text-muted max-w-3-5">
              Выберите удобный способ добавления объекта
            </p>
            <div class="flex flex-col space-y-2 w-40">
              <router-link
                tag="button"
                class="btn btn-xs btn-primary flex-grow"
                :to="{ name: 'objects.new' }">
                Добавить вручную
              </router-link>
              <VueUpload
                class="cursor-pointer"
                ref="upload"
                @input-file="onInputCSV"
                v-model="csv">
                <button class="btn btn-xs btn-outline-primary flex-grow w-full">
                  Загрузить файл
                </button>
              </VueUpload>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  </div>
</template>

<script type="text/jsx">
import _ from 'lodash';
import { mapActions, mapState } from 'vuex';
import VueUpload from 'vue-upload-component';
import Table from '@/components/Table.vue';
import Modal from '@/components/Modal.vue';
import Pagination from '@/components/Pagination.vue';
import Loading from '@/components/Loading.vue';
import { importCemeteries } from '@/api/objects';
import { iwalyNotify } from '@/notify';

export default {
  components: {
    VueUpload,
    Table,
    Modal,
    Pagination,
    Loading,
  },
  data() {
    const routeQuery = this.$route.query || {};
    const sort = routeQuery.sort || null;
    const dir = routeQuery.dir || 'desc';

    return {
      limit: 100,
      page: Math.max(1, Number(routeQuery.page || 1) || 1),
      orderBy: sort ? [{ column: sort, descending: dir === 'desc' ? 1 : 0 }] : [],
      query: String(routeQuery.search || ''),
      csv: [],
      syncRouteLocked: false,
    };
  },
  computed: {
    ...mapState({
      payload: (state) => state.objects.data,
    }),
    columns() {
      return [
        {
          label: '№',
          field: 'id',
          tdClass: 'align-middle',
          cell: ({ row }) => <div class="flex flex-col items-start">
            <b>{ row.id }</b>
          </div>,
          sortable: true,
        },
        {
          label: 'Создан',
          field: 'createdAt',
          tdClass: 'align-middle',
          cell: ({ row }) => <b>
            { this.$moment(row.createdAt, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY') }
          </b>,
          sortable: true,
        },
        {
          label: 'Название',
          field: 'name',
          tdClass: 'align-middle',
          cell: ({ row }) => <b>{ _.get(row, 'name') }</b>,
          sortable: true,
        },
        {
          label: 'Регион',
          field: 'regionName',
          tdClass: 'align-middle',
          cell: ({ row }) => <div>{ _.get(row, 'cemetery.district.region.name') }</div>,
          sortable: true,
        },
        {
          label: 'Город',
          field: 'districtName',
          tdClass: 'align-middle',
          cell: ({ row }) => <div>{ _.get(row, 'cemetery.district.name') }</div>,
          sortable: true,
        },
        {
          label: 'Кладбище',
          field: 'cemeteryName',
          tdClass: 'align-middle',
          cell: ({ row }) => <div>{ _.get(row, 'cemetery.name') }</div>,
          sortable: true,
        },
        {
          label: 'Тип объекта',
          field: 'celebrity',
          tdClass: 'align-middle',
          cell: ({ row }) => {
            const celebrity = !!_.get(row, 'celebrity');
            if (celebrity) {
              return <div>Знаменитость</div>;
            }
            return <div>Частный</div>;
          },
          sortable: true,
        },
      ];
    },
    offset() {
      return (this.page - 1) * this.limit;
    },
    objects() {
      return _.get(this.payload, 'payload') || [];
    },
    total() {
      return _.get(this.payload, 'total') || null;
    },
    pageCount() {
      return Math.ceil(this.total / this.limit);
    },
    waitPending() {
      return this.$wait.is('fetch.objects');
    },
  },
  methods: {
    ...mapActions({
      fetch: 'objects/ACT_FETCH_OBJECTS',
      uploadCsv: 'objects/ACT_UPLOAD_CSV',
    }),
    getDefaultOrderBy() {
      return [{ column: 'id', descending: 1 }];
    },
    getNormalizedOrderBy() {
      return _.isEqual(this.orderBy, []) ? this.getDefaultOrderBy() : this.orderBy;
    },
    buildListQuery() {
      const query = {};
      const search = String(this.query || '').trim();
      const sort = _.get(this.orderBy, '0.column');
      const descending = _.get(this.orderBy, '0.descending');

      if (this.page > 1) query.page = String(this.page);
      if (search) query.search = search;
      if (sort) {
        query.sort = String(sort);
        query.dir = descending ? 'desc' : 'asc';
      }
      return query;
    },
    normalizeRouteQuery(routeQuery = this.$route.query) {
      const normalized = {};
      ['page', 'search', 'sort', 'dir'].forEach((key) => {
        const value = routeQuery ? routeQuery[key] : undefined;
        if (value !== undefined && value !== null && String(value) !== '') {
          normalized[key] = String(value);
        }
      });
      return normalized;
    },
    syncRouteQuery() {
      if (this.syncRouteLocked) return;
      const nextListQuery = this.buildListQuery();
      const currentListQuery = this.normalizeRouteQuery();
      if (_.isEqual(currentListQuery, nextListQuery)) return;

      const nextQuery = { ...this.$route.query };
      ['page', 'search', 'sort', 'dir'].forEach((key) => delete nextQuery[key]);
      Object.assign(nextQuery, nextListQuery);
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: nextQuery,
      }).catch(() => {});
    },
    applyRouteQuery(routeQuery = this.$route.query) {
      this.syncRouteLocked = true;
      this.page = Math.max(1, Number(routeQuery.page || 1) || 1);
      this.query = String(routeQuery.search || '');
      if (routeQuery.sort) {
        this.orderBy = [{
          column: routeQuery.sort,
          descending: routeQuery.dir === 'asc' ? 0 : 1,
        }];
      } else {
        this.orderBy = [];
      }
      this.$eventBus.$emit('find.object.value', this.query);
      this.$nextTick(() => {
        this.syncRouteLocked = false;
      });
    },
    resetPageOrFetch() {
      if (this.page !== 1) {
        this.page = 1;
        return;
      }
      this.syncRouteQuery();
      this.fetchPayload();
    },
    applySearch(value) {
      const next = String(value || '').trim();
      if (next === this.query) {
        this.resetPageOrFetch();
        return;
      }
      this.query = next;
    },
    fetchPayload() {
      this.fetch({
        limit: this.limit,
        offset: this.offset,
        search: String(this.query || '').trim(),
        orderBy: this.getNormalizedOrderBy(),
      });
    },
    onPageChange(event) {
      this.page = event;
    },
    onRowClick({ row: event }) {
      this.$router.push({
        name: 'objects.details',
        params: {
          id: event.id,
        },
      });
    },
    onInputCSV() {
      const selected = this.csv[0];
      if (selected) {
        const csv = selected.file;
        const fd = new FormData();
        fd.append('csv', csv);
        this.uploadCsv(fd).then(() => {
          this.$bvModal.hide('add');
          this.fetchPayload();
        });
      }
    },
    async onInputUpdateCemeteries(e) {
      if (e?.file) {
        const { file } = e;
        const fd = new FormData();
        fd.append('file', file);
        this.$wait.start('update.cemeteries');
        try {
          await importCemeteries(fd);
          iwalyNotify.success({
            text: 'Справочник успешно обновлен',
          });
        } catch (err) {
          iwalyNotify.error({
            text: 'Ошибка во время обновления справочника',
          });
        } finally {
          this.$wait.end('update.cemeteries');
        }
      }
    },
  },
  watch: {
    page() {
      if (this.syncRouteLocked) return;
      this.syncRouteQuery();
      this.fetchPayload();
    },
    orderBy: {
      deep: true,
      handler() {
        if (this.syncRouteLocked) return;
        this.resetPageOrFetch();
      },
    },
    query() {
      if (this.syncRouteLocked) return;
      this.$eventBus.$emit('find.object.value', this.query);
      this.resetPageOrFetch();
    },
    '$route.query': {
      deep: true,
      handler(value) {
        const routeState = this.normalizeRouteQuery(value);
        const currentState = this.buildListQuery();
        if (_.isEqual(routeState, currentState)) return;

        this.applyRouteQuery(value);
        this.$nextTick(() => this.fetchPayload());
      },
    },
  },
  mounted() {
    this.$eventBus.$emit('find.object.value', this.query);
    this.fetchPayload();
    this.$eventBus.$on('find.object', this.applySearch);
  },
  beforeDestroy() {
    this.$eventBus.$off('find.object', this.applySearch);
    this.$wait.end('update.cemeteries');
  },
};
</script>
